import { createSlice } from '@reduxjs/toolkit';

import {getGateEntries, createGateEntries} from '../../apis';

export const gateEntryPlatform = createSlice({

    name: 'gateEntry',
    initialState: {
        loading: false,
        error: '',
        getGateEntriesData: [],
        createGateEntriesSuccess: false,
    },
    reducers: {
        clear: (state, action) => {
            return {
              ...state,
              [action.payload.key]: action.payload.value
            }
          }
    },
    extraReducers: (builder) => {
        builder.addCase(getGateEntries.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getGateEntries.fulfilled, (state, action) => {
            state.loading = false;
            state.getGateEntriesData = action.payload.data
        })
        builder.addCase(getGateEntries.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(createGateEntries.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createGateEntries.fulfilled, (state, action) => {
            state.loading = false;
            state.createGateEntriesSuccess = true
        })
        builder.addCase(createGateEntries.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const { clear } = gateEntryPlatform.actions

export default gateEntryPlatform.reducer